class KeyfiguresAnimation {
  constructor() {
    this.container = document.querySelector('.ns-keyfigures-animation');
    if (!this.container) return;

    this.chartContainer = this.container.querySelector('.ns-keyfigures-animation__animation .ns-keyfigures-animation__svg');
    this.totalNumberElement = this.container.querySelector('.ns-keyfigures-animation__total-number');
    this.titleContainer = this.container.querySelector('.ns-keyfigures-animation__container');
    this.figures = Array.from(this.container.querySelectorAll('.ns-keyfigure-animation__number'));

    this.colors = [
      '#FF5400',  // Orange
      '#FFFA82',  // Gelb
      '#C7E0ED',  // Blau
      '#243B26'   // Grau
    ];

    // Berechne die Scroll-Höhe basierend auf der tatsächlichen Container-Höhe
    const viewportHeight = window.innerHeight;
    const animationHeight = viewportHeight; // Changed from fixed height to viewport height
    const titleHeight = 30;
    const marginBottom = 0;

    // Mehr Scroll-Raum für längere Animation
    this.scrollHeight = animationHeight + titleHeight + marginBottom + viewportHeight;

    this.progress = 0;
    this.lastProgress = 0;

    // Header-Höhe basierend auf Viewport-Breite
    this.headerHeight = window.innerWidth >= 1024 ? 100 : 60; // Desktop: 100px, Mobile: 60px

    this.init();
    this.setupAnimation();

    // Event Listener für Resize hinzufügen
    window.addEventListener('resize', () => {
      this.chartContainer.innerHTML = ''; // SVG löschen
      this.createSVG(); // SVG neu erstellen
    });
  }

  init() {

    this.container.style.height = `${this.scrollHeight}px`;

    // Hole alle Elemente und ordne sie in der gewünschten Reihenfolge
    const allFigures = Array.from(this.container.querySelectorAll('.ns-keyfigure-animation'));

    // Alle Elemente initial unsichtbar machen
    allFigures.forEach(figure => figure.classList.remove('is-visible'));

    // Erstes Keyfigure sofort sichtbar machen
    if (allFigures[1]) { // Wir nehmen das zweite Element, da es in der neuen Reihenfolge das erste ist
      allFigures[1].classList.add('is-visible');
    }

    // Speichere die kompletten Elemente für die Animation
    this.figureElements = [
      allFigures[1],  // zweites Element
      allFigures[3],  // viertes Element
      allFigures[2],  // drittes Element
      allFigures[0]   // erstes Element
    ];

    // Extrahiere die Zahlen-Elemente wie bisher
    this.figures = this.figureElements.map(el => el.querySelector('.ns-keyfigure-animation__number'));

    const values = this.figures.map(el => parseFloat(el.textContent.replace('.', '')));
    const total = values.reduce((acc, curr) => acc + curr, 0);

    // Erstelle die Segmente in der richtigen Reihenfolge
    this.segments = values.map((value, index) => ({
      percentage: (value / total) * 100,
      color: this.colors[index],
      value: value
    }));

    this.createSVG();
    this.totalValue = total;
    this.totalNumberElement.textContent = '0';
  }

  createSVG() {
    const isMobile = window.innerWidth < 992;
    const size = isMobile ? 300 : 366; // Responsive size
    const strokeWidth = isMobile ? 20 : 24; // Angepasste Stroke-Breite für Mobile
    const radius = isMobile ? 140 : 170; // Angepasster Radius für Mobile
    const center = size / 2;

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', size);
    svg.setAttribute('height', size);
    svg.setAttribute('viewBox', `0 0 ${size} ${size}`);

    let startAngle = -20.3333;
    this.paths = [];

    this.segments.forEach((segment, index) => {
      const endAngle = startAngle + (segment.percentage / 100) * 360;
      const path = this.createSegmentPath(center, center, radius, startAngle, endAngle, strokeWidth);
      path.style.stroke = segment.color;
      path.style.strokeWidth = strokeWidth;
      path.style.fill = 'none';
      path.style.strokeDasharray = path.getTotalLength();

      // Erster Pfad ist sofort sichtbar
      if (index === 0) {
        path.style.strokeDashoffset = 0;
      } else {
        path.style.strokeDashoffset = path.getTotalLength();
      }

      svg.appendChild(path);
      this.paths.push({
        element: path,
        length: path.getTotalLength(),
        startAngle,
        endAngle
      });
      startAngle = endAngle;
    });

    this.chartContainer.appendChild(svg);
  }

  createSegmentPath(cx, cy, radius, startAngle, endAngle, strokeWidth) {
    const start = this.polarToCartesian(cx, cy, radius, startAngle);
    const end = this.polarToCartesian(cx, cy, radius, endAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

    const d = [
      "M", start.x, start.y,
      "A", radius, radius, 0, largeArcFlag, 1, end.x, end.y
    ].join(" ");

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', d);
    return path;
  }

  polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
      x: centerX + (radius * Math.cos(angleInRadians)),
      y: centerY + (radius * Math.sin(angleInRadians))
    };
  }

  setupAnimation() {
    window.addEventListener('scroll', () => {
      const rect = this.container.getBoundingClientRect();
      const viewportHeight = window.innerHeight * 1.2;
      const titleHeight = this.titleContainer.offsetHeight;

      // Prüfe, ob der Container seine sticky Position erreicht hat
      const containerTop = rect.top;
      const stickyOffset = 150;

      // Berechne den Animation-Progress erst, wenn der Container sticky ist
      if (containerTop <= stickyOffset) {
        // Längere Animation durch größeren Divisor
        const stickyProgress = Math.min(1, Math.abs(containerTop - stickyOffset) / (viewportHeight * .8));

        this.progress = Math.max(0, Math.min(1, stickyProgress));

        if (this.lastProgress !== this.progress) {
          this.lastProgress = this.progress;
          this.updateAnimation();
        }
      } else {
        // Wenn noch nicht sticky, setze Progress auf 0
        this.progress = 0;
        this.updateAnimation();
      }
    });

    window.addEventListener('resize', () => {
      this.headerHeight = window.innerWidth >= 1024 ? 100 : 60;
      this.titleContainer.style.top = `160px`;
    });
  }

  updateAnimation() {
    const totalSegments = this.segments.length;
    const progressPerSegment = 1 / totalSegments;
    const totalElement = this.container.querySelector('.ns-keyfigures-animation__total');

    // Remove active class from all figures first
    this.figureElements.forEach(figure => {
        figure.classList.remove('is-active');
    });

    if (this.progress === 0) {
        this.figureElements.forEach((element, idx) => {
            element.classList.remove('is-visible');
        });
        // Erstes Element ist nur aktiv, wenn es sichtbar ist
        this.figureElements[0].classList.add('is-visible');
        totalElement.classList.remove('is-visible');
    }

    let lastVisibleIndex = 0;
    const activationThreshold = 0.5;

    this.paths.forEach((path, index) => {
        const segmentStart = index * progressPerSegment;
        const segmentEnd = (index + 1) * progressPerSegment;

        let segmentProgress;
        if (this.progress <= segmentStart) {
            segmentProgress = 0;
            this.figureElements[index].classList.remove('is-visible');
        } else {
            segmentProgress = this.progress > segmentEnd ? 1 : (this.progress - segmentStart) / progressPerSegment;
            this.figureElements[index].classList.add('is-visible');

            if (segmentProgress >= activationThreshold) {
                lastVisibleIndex = index;
            }
        }

        path.element.style.strokeDashoffset = path.length * (1 - segmentProgress);

        if (index === this.segments.length - 1 && this.progress >= 1) {
            totalElement.classList.add('is-visible');
            this.totalNumberElement.textContent = Math.round(this.totalValue).toLocaleString('de-DE').replace(',', '.');
        } else if (index === this.segments.length - 1) {
            totalElement.classList.remove('is-visible');
        }
    });

    // Setze die aktive Klasse nur wenn der Fortschritt deutlich im Segment ist
    this.figureElements.forEach((figure, index) => {
        if (index === lastVisibleIndex) {
            if (!figure.classList.contains('is-active')) {
                figure.classList.add('is-active');
            }
        } else {
            figure.classList.remove('is-active');
        }
    });
  }
} export default KeyfiguresAnimation;
